import styled from 'styled-components';
import { Icon } from '@iconify/react';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  gap: 50px;
  padding: 20px;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;
`;

export const Title = styled.span`
  font-weight: 700;
  font-size: 20px;
`;
export const Subtitle = styled.span`
  font-weight: 700;
  font-size: 15px;

  color: ${props => props.theme.colors.grey_text}
`;

export const Observacao = styled.span`
  font-size: 12px;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  max-width: 100%;
  gap: 5px;
`;

export const SetpTwoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
`;

export const SubtitleContainer = styled.div`
  overflow-x: auto;
  white-space: nowrap;
  
  &::-webkit-scrollbar {
    display: none;
  }
  
`;

export const TextContainer = styled.div`
  border-radius: 10px;
  max-width: 100%;

  border: 2px;
  border-left: 8px;
  border-right: 8px;
  border-style: solid;
  border-color: ${props => props.theme.colors.primary};
  padding: 7px;

  display: flex;
  flex-direction: row;
  
`;

export const IconDone = styled(Icon)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 8px
`;


